"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = void 0;
exports.initializeLogger = initializeLogger;
const logger_1 = require("./logger");
const shouldInstantiateLogger = process.env.INIT_LOGGER?.toLowerCase() ?? 'true' === 'true';
let logger;
function initializeLogger(options) {
    exports.log = logger = logger_1.Logger.getInstance(options);
    logger.debug('Logger has been initialized.', { options });
    return logger;
}
if (shouldInstantiateLogger) {
    exports.log = logger = initializeLogger();
    logger.debug('Logger was automatically initialized.');
}
else {
    const handler = {
        get() {
            throw new Error('Logger is not initialized. Please initialize the logger before use.');
        },
    };
    exports.log = logger = new Proxy({}, handler);
    console.warn('Logger is not initialized.');
}
//# sourceMappingURL=instance.js.map